// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1v1Gq","tabsBox":"styles_tabsBox__2Lmdv","createButton":"styles_createButton__abxXB"};